<template>
	<div class="repeater-wrap">
    <span class="label">{{ title }}</span>
    <div :class="repeaterClass()">
  		<button 
        :class="repeaterInputClass()"
  			@click="openPanel">
        <span class="repeater__total">{{ getDisplayValue }}</span>
  		</button>
      <Icon icon="repeater-list"></Icon>
    </div>
	</div>
</template>

<script>

import Icon  from './Icon.vue'

export default {

  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
  components: {
    Icon
  },  

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    openPanel() {

      this.$parent.$data.subpanel.field    = this.field;
      this.$parent.$data.subpanel.proto    = this.proto;
      this.$parent.$data.subpanel.autofill = this.autofill;
      this.$parent.$data.subpanel.title    = this.title;
      this.$parent.$data.subpanel.setting  = this.setting;
      this.$parent.$data.subpanel.view     = 'repeaterForm';

      this.$parent.$data.subpanel.data     = this.$store.getters.getRepeaterData(this.$parent.$data.subpanel);
      this.$parent.$data.subpanel.save     = JSON.parse( JSON.stringify( this.$parent.$data.subpanel.data ));

      this.$parent.$data.subpanel.state = 'active';

    },

    repeaterClass() {

      var c = 'input-wrap';

      if ( this.totalby !== 'none' ) {

        c += ' input-wrap--currency';

      }

      return c;

    },

    repeaterInputClass() {

      var c = 'input';

      if ( this.totalby !== 'none' ) {

        c += ' input--currency';

      }

      c += ' repeater__button';

      return c;

    }

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    getDisplayValue() {

      var total = 0;

      var vars = { 'field': this.field, 'totalby': this.totalby, 'setting' : this.setting };

      if ( this.totalby === 'none' ) { 

        var data = this.$store.getters.getRepeaterData(vars);

        return data.length + ' ' + this._translate('repeater.totalRows');

      }      

      if (vars.field) {

        if ( this.display === 'last' ) {

          var last = this.$store.getters.getRepeaterLastValue(vars);
          return window.thousandSeparators(last.toFixed(2));

        }

        var total = this.$store.getters.getRepeaterTotal(vars);
        return window.thousandSeparators(total.toFixed(2));  

      }      

    }

  },

  props : [
  	'title',
  	'field',
    'proto',
    'autofill',
    'totalby',
    'display',
    'setting',     
  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .repeater-wrap {

    // border: 1px solid red;
    position: relative;
    margin: 0 0 .75rem;

    .icon {

      position: absolute;
      right: -1.5rem;
      top: 1em;

      width: .75rem;
      height: .75rem;

    }

    .icon__svg {

      fill: #444;
      stroke: #444;
    }

  }


</style>



// WEBPACK FOOTER //
// Repeater.vue?6f133787